import React, { useState, useEffect } from "react";
import "./GeneralSettings.scss";
import ManageStages from "../../components/manageStages/ManageStages";
import ManageRoles from "../../components/manageRoles/ManageRoles";
import ManageExpertise from "../../components/manageExpertise/ManageExpertise";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../components/loader/Loader";

const GeneralSettings = () => {
  const [selectedTab, setSelectedTab] = useState("expertise-tab");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
      setLoading(false);
  }, []);
  const handleTabClick = (tab) => {
    setLoading(true); 
    setSelectedTab(tab); 
    setLoading(false); 
  };
  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <div className="content-inner">
      <div className="general-settings">
      <div className="common-tab">
      <div
          className={`tabButton ${
            selectedTab === "expertise-tab" ? "active" : ""
          }`}
          onClick={() => handleTabClick("expertise-tab")}>
          Expertise
        </div>
        <div
          className={`tabButton ${
            selectedTab === "stages-tab" ? "active" : ""
          }`}
          onClick={() => handleTabClick("stages-tab")}
        >
          Stages
        </div>
        

      </div>
      <div>
      {selectedTab === "expertise-tab" && (
        <ManageExpertise/>
      )}
      {selectedTab === "stages-tab" && (
        <ManageStages/>
      )}
      
      </div>

      </div>
      {/* <ToastContainer autoClose={1500} /> */}
      
    </div>
    )}
    </>
  );
};

export default GeneralSettings;
